import { NgModule } from '@angular/core';

import { TrainingPageModule } from 'pages/training/training.module';
import { WorkoutDetailPageModule } from 'pages/workout-detail/workout-detail.module';
import { ChangeWorkoutPageModule } from 'pages/change-workout-page/change-workout-page.module';
import { TrainingOverviewPageModule } from 'pages/training-overview/training-overview.module';
import { EditWorkoutsPageModule } from 'pages/edit-workouts/edit-workouts-page.module';
import { ProgramSettingsPageModule } from 'pages/program-settings-page/program-settings-page.module';
import { AdvancedTrainingMethodsPageModule } from 'pages/advanced-training-methods-page/advanced-training-methods-page.module';
import { UpdatePlanOptionsPageModule } from 'pages/update-plan-options/update-plan-options.module';
import { EditTrainingGoalPageModule } from 'pages/edit-training-goal/edit-training-goal-page.module';
import { MuscleVolumePageModule } from 'pages/muscle-volume-page/muscle-volume-page.module';
import { EditExercisePageModule } from 'pages/edit-exercise/edit-exercise-page.module';
import { ViewExercisePageModule } from 'pages/view-exercise/view-exercise-page.module';
import { ExerciseConfigurationPageModule } from 'pages/exercise-configuration/exercise-configuration-page.module';
import { ExerciseDiffPageModule } from 'pages/exercise-diff/exercise-diff-page.module';
import { ExerciseStatsPageModule } from 'pages/exercise-stats/exercise-stats.module';
import { ExerciseSwitchPageModule } from 'pages/exercise-switch/exercise-switch.module';
import { EquipmentEditPageModule } from 'pages/equipment/equipment-edit-page.module';
import { EquipmentSearchPageModule } from 'pages/equipment/equipment-search-page.module';

const TRAINING_PAGE_MODULES = [
  TrainingPageModule,
  WorkoutDetailPageModule,
  ChangeWorkoutPageModule,
  TrainingOverviewPageModule,
  EditWorkoutsPageModule,
  ProgramSettingsPageModule,
  AdvancedTrainingMethodsPageModule,
  UpdatePlanOptionsPageModule,
  EditTrainingGoalPageModule,
  MuscleVolumePageModule,
  EditExercisePageModule,
  ViewExercisePageModule,
  ExerciseConfigurationPageModule,
  ExerciseDiffPageModule,
  ExerciseStatsPageModule,
  ExerciseSwitchPageModule,
  EquipmentEditPageModule,
  EquipmentSearchPageModule,
];

/**
 * The workout, exercise and training-programme screens.
 *
 * One of the app's per-area page groups: it only groups page modules together,
 * declaring nothing of its own and adding no providers. Why these files exist and
 * what keeps them honest: `design-docs/angular-components.md`, "Creating New
 * Components", step 4.
 */
@NgModule({
  imports: TRAINING_PAGE_MODULES,
  exports: TRAINING_PAGE_MODULES,
})
export class TrainingPagesModule { }
